import { apiClient, retryRequest } from './httpClient';

export async function getItems(endpoint, params = {}, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'GET',
        params,     
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));

        return response.data;

    } catch (error) {
        const err = new Error(error.data || 'GET request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'GET';
        throw err;
    }
}
